/**
 * L'état de la relance « Personnalise ton profil », pur : l'étape, le sport touché (puis envoyé),
 * l'envoi et le refus du serveur.
 *
 * Les étapes de l'ancienne modale (`ProfileCustomizationPromptModal.js`) : le sport, l'envoi (ici
 * le bouton qui tourne, `saving`), l'accusé, puis l'avatar. Un refus ramène au choix du sport. Ce
 * qui ne peut pas arriver (un sport touché pendant l'envoi, une réponse sans envoi) est tenu par la
 * feuille et par `useApiMutation`, pas ici.
 */
import { type UIStudentProfilePromptStep } from "../../../types"

export type StudentProfilePromptUiState = {
    step: UIStudentProfilePromptStep
    /** Le sport touché, puis envoyé. `null` : celui du profil reste coché. */
    touchedSport: string | null
    saving: boolean
    error: string | null
}

export type StudentProfilePromptUiAction =
    | { type: "TOUCH"; sport: string }
    | { type: "SEND"; sport: string }
    | { type: "SAVED" }
    | { type: "FAILED"; message: string }
    | { type: "OFFER_AVATAR" }

export const initialStudentProfilePromptUiState: StudentProfilePromptUiState = {
    step: "sport",
    touchedSport: null,
    saving: false,
    error: null,
}

export function studentProfilePromptUiReducer(
    state: StudentProfilePromptUiState,
    action: StudentProfilePromptUiAction
): StudentProfilePromptUiState {
    switch (action.type) {
        case "TOUCH":
            return { ...state, touchedSport: action.sport, error: null }
        case "SEND":
            // Le sport envoyé reste coché : c'est lui que l'accusé dit.
            return { ...state, touchedSport: action.sport, saving: true, error: null }
        case "SAVED":
            return { ...state, step: "saved", saving: false }
        case "FAILED":
            return { ...state, saving: false, error: action.message }
        case "OFFER_AVATAR":
            return { ...state, step: "avatar" }
        default:
            return state
    }
}
